




























import { Component, Prop, Vue } from 'vue-property-decorator';
import { DamageStatus } from 'admiral-core';
import Multiselect from 'vue-multiselect';
import Avatar from '@/components/common/Avatar.vue';
import { Util } from '@/utils/Util';
import { CheckIcon } from 'vue-feather-icons';
import DamageStatusBadge from '@/components/common/DamageStatusBadge.vue';

@Component({
  components: { DamageStatusBadge, Multiselect, Avatar, CheckIcon },
})
export default class DamageStatusSelect extends Vue {
  @Prop({ type: Boolean, default: () => false })
  multiple!: boolean;

  @Prop()
  status!: DamageStatus | DamageStatus[];

  get selectableStatus() {
    return [
      DamageStatus.NEW,
      DamageStatus.IN_PROGRESS,
      DamageStatus.PENDING,
      DamageStatus.SUBMITTED,
      DamageStatus.COMPLETED,
      DamageStatus.DECLINED,
    ];
  }

  updateDamageStatus(status: DamageStatus | DamageStatus[]) {
    this.$emit('update-damage-status', status);
  }

  formatStatusLabel(status: DamageStatus) {
    return Util.formatDamageStatus(status);
  }

  formatStatusClass(status: DamageStatus) {
    return Util.formatDamageStatusClass(status);
  }

  isSelected(status: DamageStatus) {
    if (Array.isArray(this.status)) {
      return this.status.find((s: DamageStatus) => s === status);
    } else {
      return this.status === status;
    }
  }
}
